import { Model } from "@vuex-orm/core";
import Project from "./Project";

export default class Medium extends Model {
  static entity = "mediums";
  static url = "/medium";
  static friendlyName = "Medium"

  static fields() {
    return {
      id: this.attr(0),
      code: this.attr(null),
      name: this.attr(null),
      createdAt: this.attr(null),
      updatedAt: this.attr(null),
      projectId: this.attr(null),
      project: this.belongsTo(Project, "projectId"),
    };
  }
}
